import type { SupportedLanguage, TranslationTree } from './types';
import { fr } from './dictionaries/fr';
import { en } from './dictionaries/en';
import { de } from './dictionaries/de';

export type { SupportedLanguage, TranslationTree } from './types';

export const translations = {
  fr,
  en,
  de,
} satisfies Record<SupportedLanguage, TranslationTree>;

export function getTranslation(dictionary: TranslationTree, key: string): string | undefined {
  try {
    return key.split('.').reduce<string | TranslationTree | undefined>((acc, segment) => {
      if (acc && typeof acc === 'object') {
        return acc[segment];
      }
      return undefined;
    }, dictionary) as string | undefined;
  } catch {
    console.warn('Error getting translation for key:', key);
    return key;
  }
}
